import commandCenterCSS from './command-center-theme.css?raw'

export interface ThemeEntry {
  id: string
  name: string
  description: string
  css: string
  builtIn: boolean
}

export const builtInThemes: ThemeEntry[] = [
  {
    id: 'default',
    name: 'Default (Lara Light Blue)',
    description: 'Built-in PrimeReact + Tailwind theme',
    css: '',
    builtIn: true,
  },
  {
    id: 'command-center',
    name: 'Command Center',
    description: 'Dark sidebar + modern dashboard design system',
    css: commandCenterCSS,
    builtIn: true,
  },
]
